import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';

import { Observable, throwError } from 'rxjs';
import { AdvertiserAffiliate } from '../_models';
import { ArrayResponse, BaseResponse, ListResponse } from '../_common';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class AdvertiserAffiliateService {
    constructor(private http: HttpClient) { }

    getAffiliate(affiliateId: any): Observable<AdvertiserAffiliate> { //detail
      return this.http.get(`${environment.apiUrl}/offer-stream/advertiser/affiliate/find/${affiliateId}`)
      .pipe(
        map((data: BaseResponse) => {
          return new AdvertiserAffiliate().deserialize(data.data);
        }),
        catchError(error => throwError(error.message || error))
      );
    }

    getAll(advertiserId: any, filter: any): Observable<ListResponse>  { //listing
      return this.http.post(`${environment.apiUrl}/offer-stream/advertiser/affiliate/${advertiserId}/list`, JSON.stringify(filter))
      .pipe(
        map((data: ListResponse) => {
          if(data.status == 1 && data.data.list == undefined){
            return null;
          }else{
            return new ListResponse().deserialize(data, AdvertiserAffiliate);
          }
        }),
        catchError(error => throwError(error.message || error))
      );
    }

    addAffiliate(advertiserId: any, data): Observable<BaseResponse> {
      return this.http.post(`${environment.apiUrl}/offer-stream/advertiser/affiliate/${advertiserId}/save`, JSON.stringify(data))
      .pipe(
        map((data: BaseResponse) => {
          return data;
        }),
        catchError(error => throwError(error.message || error))
      );
    }

    updateAffiliate(data): Observable<BaseResponse> {
      return this.http.post(`${environment.apiUrl}/offer-stream/advertiser/affiliate/update/${data.id}`, JSON.stringify(data))
      .pipe(
        map((data: BaseResponse) => {
          return data;
        }),
        catchError(error => throwError(error.message || error))
      );
    }

    deleteAffiliate(affiliateId: any): Observable<BaseResponse> {
      return this.http.delete(`${environment.apiUrl}/offer-stream/advertiser/affiliate/delete/${affiliateId}`)
      .pipe(
        map((data: BaseResponse) => {
          return data;
        }),
        catchError(error => throwError(error.message || error))
      );
    }

    getAllForSelection(advertiserId: number): Observable<ArrayResponse> {
      return this.http.get(`${environment.apiUrl}/offer-stream/advertiser/list-all/${advertiserId}`)
      .pipe(
        map((data: any) => {
          if(data.status == 1 && data.data == undefined){
            return null;
          }else{
            return new ArrayResponse().deserialize(data, AdvertiserAffiliate);
          }
        }),
        catchError(error => throwError(error.message || error))
      );
    }
}
